import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { Suspense } from 'react'
import { useTranslation } from 'react-i18next'

import { Header } from '~/components/Molecules/Header'
import { CardBanner } from '~/components/Organisms/Cards/Banner'
import { CompanyCodeCard } from '~/components/Organisms/Cards/CompanyCode'
import { ContactCard } from '~/components/Organisms/Cards/Contact'
import { EventCard } from '~/components/Organisms/Cards/Event'
import { ManagerTrainingCard } from '~/components/Organisms/Cards/ManagerTraining'
import { ReportCard } from '~/components/Organisms/Cards/Report'

export function Home() {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      gap={theme.spacing['4XL']}
      bgcolor={theme.palette.background.page}
      padding={`${theme.spacing.XXL} ${theme.spacing['4XL']}`}
      sx={{ marginTop: theme.spacing.M, borderTopLeftRadius: theme.radius.XL }}
    >
      <Header title={t('common:home')} />
      <Box display="flex" flexDirection="column" gap={theme.spacing['3XL']}>
        <CardBanner />
        <Box display="flex" gap={theme.spacing['5XL']}>
          <Suspense fallback={<></>}>
            <ContactCard />
          </Suspense>
          <Box display="flex" width="100%" flexDirection="column" gap={theme.spacing.L}>
            <Box display="flex" width={'100%'} flexDirection="column" gap={theme.spacing['3XL']}>
              <ReportCard />
              <ManagerTrainingCard />
            </Box>
          </Box>
          <Box display="flex" width={'350px'} flexShrink={0} flexDirection="column" gap={theme.spacing['3XL']}>
            <CompanyCodeCard />
            <EventCard />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
